import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { aboutContent } from '../mock';

const About = () => {
  const a = aboutContent;
  return (
    <section id="nosotros" className="bg-[#1E3A5F] py-20 md:py-24 relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="absolute -inset-3 border-2 border-dashed border-[#E8B84A]/60 rounded-3xl" />
          <div className="relative rounded-3xl overflow-hidden aspect-[5/4] shadow-2xl">
            <img
              src="https://images.unsplash.com/photo-1588072432836-e10032774350?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85"
              alt="Niños pequeños en clase de inglés en Pinar English Academy"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-4 right-4 bg-[#E8B84A] text-[#1E3A5F] rounded-full h-24 w-24 flex flex-col items-center justify-center shadow-lg">
              <span className="font-serif text-[14px] font-bold leading-none">Learn it</span>
              <span className="font-serif text-[10px] font-semibold tracking-widest mt-1">SPEAK IT</span>
            </div>
          </div>
          <Sparkles className="absolute -top-6 -left-6 h-8 w-8 text-[#E8B84A]" />
        </div>

        <div>
          <span className="inline-block text-[11px] font-semibold tracking-widest text-[#E8B84A] px-3 py-1 border border-[#E8B84A]/40 rounded-full">
            {a.eyebrow.toUpperCase()}
          </span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl leading-[1.05] font-bold text-white">
            {a.title}{' '}
            <span className="text-[#E8B84A] italic">{a.titleHighlight}</span>
          </h2>
          <p className="mt-6 text-[15px] text-white/75 leading-relaxed max-w-lg">
            {a.description}
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
            {a.bullets.map((b) => (
              <li key={b} className="flex items-center gap-3">
                <span className="h-5 w-5 rounded-full bg-[#E8B84A] flex items-center justify-center flex-shrink-0">
                  <Check className="h-3 w-3 text-[#1E3A5F]" strokeWidth={3} />
                </span>
                <span className="text-[14px] text-white">{b}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
